module.exports = __webpack_public_path__ + "images/8864623f.png";